import { callAPI, HTTPMethod } from "./API";
import { PresignUrl, PresignUrlRequest } from "../model/PresignUrl";

export async function getPresingUrl(request: PresignUrlRequest): Promise<PresignUrl> {
    return await callAPI("/presign-url/generate", {
        method: HTTPMethod.POST,
        body: request
    });
}